import React, { useState, useEffect } from "react";
import "../../styles/BuildingPreviews/UnitList.css"; // ✅ Updated styles for table


const API_BASE_URL = import.meta.env.VITE_API_URL;


const availabilityStatusMap = {
    0: { text: "✅ Available", class: "available" },
    1: { text: "⏳ Currently Held", class: "held" },
    2: { text: "🟡 Waitlist Only", class: "waitlist" },
    3: { text: "📝 Recently Signed", class: "signed" }
};

const UnitList = ({ units, onViewDetails }) => {
    const [sortKey, setSortKey] = useState("UnitNumber");
    const [sortedUnits, setSortedUnits] = useState([...units].sort((a, b) => a.UnitNumber - b.UnitNumber));
    const [unitStatuses, setUnitStatuses] = useState({}); // Store live statuses

    // 🔹 Fetch updated availability statuses every 5 seconds
    useEffect(() => {
        const fetchOfferStatuses = async () => {
            try {
                const response = await fetch("${API_BASE_URL}/offers/status/all"); // ✅ Correct API call
                if (!response.ok) throw new Error("Failed to fetch offer statuses");

                const updatedOffers = await response.json();
                const statusMap = updatedOffers.reduce((acc, offer) => {
                    acc[offer.OfferID] = offer.AvailabilityStatus;
                    return acc;
                }, {});

                setUnitStatuses(statusMap); // ✅ Store latest availability statuses
            } catch (err) {
                console.error("Error fetching offer statuses:", err);
            }
        };

        fetchOfferStatuses();
        const interval = setInterval(fetchOfferStatuses, 5000); // ✅ Update every 5 seconds

        return () => clearInterval(interval);
    }, []);

    // 🔹 Apply live status updates to units
    useEffect(() => {
        setSortedUnits(prevUnits =>
            [...prevUnits].map(unit => ({
                ...unit,
                AvailabilityStatus: unitStatuses[unit.OfferID] ?? unit.AvailabilityStatus // Keep existing if missing
            }))
        );
    }, [unitStatuses]);

    const handleSortChange = (key) => {
        setSortKey(key);
        const sorted = [...sortedUnits].sort((a, b) => {
            if (key === "RentAmount") return a.RentAmount - b.RentAmount;
            if (key === "AvailabilityStatus") return a.AvailabilityStatus - b.AvailabilityStatus;
            return a.UnitNumber - b.UnitNumber;
        });
        setSortedUnits(sorted);
    };

    return (
        <div className="unit-list">
            <h3 className="unit-title">🏠 Available Units</h3>

            {/* Sort Dropdown */}
            <div className="unit-sort">
                <label>Sort by: </label>
                <select value={sortKey} onChange={(e) => handleSortChange(e.target.value)}>
                    <option value="UnitNumber">Unit Number</option>
                    <option value="RentAmount">Monthly Rent</option>
                    <option value="AvailabilityStatus">Availability</option>
                </select>
            </div>

            {/* Table Layout */}
            <table className="unit-table">
                <thead>
                    <tr>
                        <th>Unit</th>
                        <th>Availability</th>
                        <th>Monthly Rent</th>
                        <th className="narrow-column"></th>
                    </tr>
                </thead>
                <tbody>
                    {sortedUnits.length > 0 ? (
                        sortedUnits.map(unit => {
							console.log(unit);
                            const statusInfo = availabilityStatusMap[unit.AvailabilityStatus] || { text: "❓ Unknown", class: "unknown" };

                            return (
                                <tr key={unit.UnitID}>
                                    <td>{unit.UnitNumber}</td>
                                    <td className={`unit-status ${statusInfo.class}`}>
                                        {statusInfo.text}
                                    </td>
                                    <td className="unit-rent">${unit.RentAmount}/month</td>
                                    <td className="narrow-column">
                                        <button
                                            className="details-btn"
                                            onClick={() => {
                                                console.log("Clicked Unit:", unit);
                                                onViewDetails(unit);
                                            }}
                                        >
                                            Details
                                        </button>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="4" style={{ textAlign: "center" }}>No units available</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default UnitList;
